export enum DeviceType {
  Console = 'console',
  Embedded = 'embedded',
  Mobile = 'mobile',
  SmartTv = 'smarttv',
  Tablet = 'tablet',
  Wearable = 'wearable',
}
